import { Box, Typography, Modal, IconButton, Backdrop, Fade } from '@mui/material'
import React, { useState, useEffect, useRef } from 'react'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import CloseIcon from '@mui/icons-material/Close'
import { getSuccessStories } from '../Apis/SuccessApis'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import 'swiper/css'

const Success = () => {
    const swiperRef = useRef(null)
    const [stories, setStories] = useState([])
    const [open, setOpen] = useState(false)
    const [selectedVideo, setSelectedVideo] = useState('')

    useEffect(() => {
        getSuccessStories().then(data => {
            if (data && data.status && Array.isArray(data.data)) {
                setStories(data.data)
            }
        })
    }, [])

    const handleOpen = (url) => {
        // Convert YouTube URL to Embed URL if needed
        let videoId = ''
        if (url.includes('v=')) {
            videoId = url.split('v=')[1].split('&')[0]
        } else if (url.includes('youtu.be/')) {
            videoId = url.split('youtu.be/')[1]
        }
        setSelectedVideo(`https://www.youtube.com/embed/${videoId}?autoplay=1`)
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        setSelectedVideo('')
    }

    return (
        <Box id="testimonials" sx={{ py: 8 }}>
            <Typography
                fontSize={'30px'}
                fontWeight="600"
                color="#ff6a00"
                mb={4}
                textAlign={'center'}
            >
                Varahi Success Stories
            </Typography>

            <Box
                sx={{ width: '100%', px: { xs: 2, md: 4 } }}
                onMouseEnter={() => {
                    swiperRef.current.swiper.autoplay.stop();
                }}
                onMouseLeave={() => {
                    if (swiperRef.current && swiperRef.current.swiper) {
                        swiperRef.current.swiper.autoplay.start();
                    }
                }}
            >
                <Swiper
                    ref={swiperRef}
                    modules={[Autoplay]}
                    spaceBetween={20}
                    slidesPerView={1.5}
                    speed={3500}
                    autoplay={{
                        delay: 0,
                        disableOnInteraction: false,
                    }}
                    className="swiper-wrapper-linear"
                    grabCursor={true}
                    breakpoints={{
                        480: {
                            slidesPerView: 2.2,
                        },
                        768: {
                            slidesPerView: 3.2,
                        },
                        1024: {
                            slidesPerView: 4.5,
                        },
                        1200: {
                            slidesPerView: 5.5,
                        },
                    }}
                    loop={stories.length >= 2}
                    style={{ padding: '10px 0' }}
                >
                    {stories.map((story, index) => (
                        <SwiperSlide key={story.id || index}>
                            <Box
                                onClick={() => handleOpen(story.YoutubeUrl)}
                                sx={{
                                    position: 'relative',
                                    width: '100%',
                                    height: 270,
                                    borderRadius: '12px',
                                    backgroundColor: '#000',
                                    overflow: 'hidden',
                                    cursor: 'pointer',
                                    '&:hover .overlay': {
                                        opacity: 1,
                                    },
                                    '&:hover img': {
                                        transform: 'scale(1.05)'
                                    }
                                }}
                            >
                                <Box
                                    component="img"
                                    src={story.Thumbnail}
                                    alt="success story"
                                    sx={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        transition: 'transform 0.3s ease'
                                    }}
                                />
                                <Box
                                    className="overlay"
                                    sx={{
                                        position: 'absolute',
                                        inset: 0,
                                        backgroundColor: 'rgba(0,0,0,0.5)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        opacity: 0,
                                        transition: 'opacity 0.3s ease',
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 50,
                                            height: 50,
                                            borderRadius: '50%',
                                            backgroundColor: '#ff6a00',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#fff',
                                            boxShadow: '0 4px 15px rgba(255,106,0,0.4)'
                                        }}
                                    >
                                        <PlayArrowIcon fontSize="large" />
                                    </Box>
                                </Box>
                            </Box>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Box>

            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        sx: { backgroundColor: 'rgba(0, 0, 0, 0.9)' }
                    }
                }}
            >
                <Fade in={open}>
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: { xs: '95%', sm: '80%', md: '70%', lg: '60%' },
                        aspectRatio: '16/9',
                        bgcolor: 'black',
                        boxShadow: 24,
                        outline: 'none',
                        borderRadius: '12px',
                        overflow: 'hidden'
                    }}>
                        <IconButton
                            onClick={handleClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: 'white',
                                zIndex: 1,
                                backgroundColor: 'rgba(0,0,0,0.5)',
                                '&:hover': { backgroundColor: 'rgba(0,0,0,0.7)' }
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <iframe
                            width="100%"
                            height="100%"
                            src={selectedVideo}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                        ></iframe>
                    </Box>
                </Fade>
            </Modal>
        </Box>
    )
}

export default Success;

